/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// @ts-ignore
import * as runtime from '../runtime';
// @ts-ignore
import type {
// @ts-ignore
  OrderPredictionRequest,
// @ts-ignore
  OrderPredictionResponse,
// @ts-ignore
  OrderPredictionStatusResponse,
} from '../models/index';
// @ts-ignore
import {
// @ts-ignore
    OrderPredictionRequestFromJSON,
// @ts-ignore
    OrderPredictionRequestToJSON,
// @ts-ignore
    OrderPredictionResponseFromJSON,
// @ts-ignore
    OrderPredictionResponseToJSON,
// @ts-ignore
    OrderPredictionStatusResponseFromJSON,
// @ts-ignore
    OrderPredictionStatusResponseToJSON,
} from '../models/index';

export interface GenerateOrderPredictionRequest {
    orderPredictionRequest: OrderPredictionRequest;
}

export interface GetOrderPredictionRequest {
    id: string;
}

/**
 * 
 */
export class OrderPredictionApi extends runtime.BaseAPI {

    /**
     * Generate order prediction
     */
    async generateOrderPredictionRaw(requestParameters: GenerateOrderPredictionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderPredictionResponse>> {
        if (requestParameters.orderPredictionRequest === null || requestParameters.orderPredictionRequest === undefined) {
            throw new runtime.RequiredError('orderPredictionRequest','Required parameter requestParameters.orderPredictionRequest was null or undefined when calling generateOrderPrediction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/order-predictions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderPredictionRequestToJSON(requestParameters.orderPredictionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderPredictionResponseFromJSON(jsonValue));
    }

    /**
     * Generate order prediction
     */
    async generateOrderPrediction(requestParameters: GenerateOrderPredictionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderPredictionResponse> {
        const response = await this.generateOrderPredictionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get order prediction
     */
    async getOrderPredictionRaw(requestParameters: GetOrderPredictionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderPredictionResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getOrderPrediction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/order-predictions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderPredictionResponseFromJSON(jsonValue));
    }

    /**
     * Get order prediction
     */
    async getOrderPrediction(requestParameters: GetOrderPredictionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderPredictionResponse> {
        const response = await this.getOrderPredictionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get order prediction status
     */
    async getOrderPredictionStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderPredictionStatusResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/order-predictions/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderPredictionStatusResponseFromJSON(jsonValue));
    }

    /**
     * Get order prediction status
     */
    async getOrderPredictionStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderPredictionStatusResponse> {
        const response = await this.getOrderPredictionStatusRaw(initOverrides);
        return await response.value();
    }

}
